import { enableReactComponents } from '@legendapp/state/config/enableReactComponents'
import { createRouter } from '@tanstack/react-router'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import { DefaultError, DefaultNotFound } from '~in-app/components'

import { queryClient } from './lib/tanstack-query/query-client'
import { routeTree } from './routeTree.gen'

dayjs.extend(utc)
dayjs.extend(timezone)
enableReactComponents()

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: 'intent',
  defaultStaleTime: 1000,
  defaultPreloadStaleTime: 10000,
  defaultGcTime: 30000,
  defaultPreloadGcTime: 30000,
  defaultErrorComponent: props => DefaultError(props),
  defaultNotFoundComponent: () => DefaultNotFound({ showBackButton: true }),
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }

  interface StaticDataRouteOption {
    privileges: string[]
  }
}
